"use client";

// import React, { useEffect } from "react";
import { useCoAgent, useCopilotChat } from "@copilotkit/react-core";
import { CopilotChat, CopilotPopup } from "@copilotkit/react-ui"; 
import { MessageRole, TextMessage } from "@copilotkit/runtime-client-gql";
// import { AgentState } from "../../lib/agentState";
import { AgentState } from "@/lib/types";
import React, { useRef, useEffect, useState } from "react";


export const RNA_VALUES = {
  user_requirement: "find the differentially expressed genes",
  data_list: [
    '/home/work/local/agent/AutoBA/examples/case1.1/data/SRR1374921_10k.fastq.gz: single-end mouse rna-seq reads, replicate 1 in LoGlu group',
    '/home/work/local/agent/AutoBA/examples/case1.1/data/SRR1374922_10k.fastq.gz: single-end mouse rna-seq reads, replicate 2 in LoGlu group',
    '/home/work/local/agent/AutoBA/examples/case1.1/data/SRR1374923_10k.fastq.gz: single-end mouse rna-seq reads, replicate 1 in HiGlu group',
    '/home/work/local/agent/AutoBA/examples/case1.1/data/SRR1374924_10k.fastq.gz: single-end mouse rna-seq reads, replicate 2 in HiGlu group',
    '/home/work/local/agent/AutoBA/examples/case1.1/data/TruSeq3-SE.fa: trimming adapter',
    '/home/work/local/agent/AutoBA/examples/case1.1/data/mm39.fa: mouse mm39 genome fasta',
    '/home/work/local/agent/AutoBA/examples/case1.1/data/mm39_index: mouse mm39 genome fasta hisat2-build index',
    '/home/work/local/agent/AutoBA/examples/case1.1/data/mm39.ncbiRefSeq.gtf: mouse mm39 genome annotation'
  ],
  output_dir: "/home/work/local/agent/AutoBA/examples/case1.1/output",
  blacklist: "fastqc",
  whitelist: "featureCounts,DESeq2"
};

export const WGA_VALUES = {
  user_requirement: "call snp with HaplotypeCaller by chromosome , hg19 refrence ,Prioritization snp related to Joubert syndrome, ",
  data_list: [
"/home/work/tools/agent/AutoBA/examples/case5.1/data/19C_5k_R1.fq.gz: Read1 Paired-End Sequencing",
"/home/work/tools/agent/AutoBA/examples/case5.1/data/19C_5k_R2.fq.gz: Read2 Paired-End Sequencing",
"/home/work/tools/agent/AutoBA/examples/case5.1/data/hg19.fa: human reference genomics hg19 has been indexed with bwa",
"/home/work/tools/agent/AutoBA/examples/case5.1/data/dbsnp_138.hg19.vcf: for gatk -known-sites vcf file"
  ],
  output_dir: "/home/work/tools/agent/AutoBA/examples/case5.1/output",
  blacklist: "fastqc",
  // whitelist: "featureCounts,DESeq2,Trimmomatic"
  whitelist: "annovar"
};

export const CIPSEQ_VALUES = {
  user_requirement: "identify genome-wide binding sites of transcription factors or histone modifications,with Peak calling and Discover motifs within the peaks,with HOMER to annotate",
  data_list: [
"/home/work/tools/agent/AutoBA/examples/mary/Chip-seq/SRR620204_100k.fastq:single-end",
"/home/work/tools/agent/AutoBA/examples/mary/Chip-seq/SRR620205_100k.fastq:single-end",
"/home/work/tools/agent/AutoBA/examples/case1.1/data/mm39.fa: mouse mm39 genome fasta",
"home/work/tools/agent/AutoBA/examples/case1.1/data/mm39_index: mouse mm39 genome fasta hisat2-build index",
"/home/work/tools/agent/AutoBA/examples/case1.1/data/mm39.ncbiRefSeq.gtf: mouse mm39 genome annotation",
  ],
  output_dir: "/home/work/tools/agent/AutoBA/examples/mary/Chip-seq/output",
  blacklist: "fastqc",
  // whitelist: "featureCounts,DESeq2,Trimmomatic"
  whitelist: ""

};

// function getDefaultValues() {
//   if (typeof window !== "undefined") {
//     const params = new URLSearchParams(window.location.search);
//     const replay = params.get("replay");
//     if (replay === "state_rnaseq.json") {
//       return { ...RNA_VALUES };
//     } else if (replay === "state_whg.json") {
//       return { ...WGA_VALUES };
//     }
//   }
//   return {
//     user_requirement: "",
//     data_list: [""],
//     output_dir: "",
//     blacklist: "",
//     whitelist: ""
//   };
// }

// export let DEFAULT_VALUES = getDefaultValues();

export let DEFAULT_VALUES ={
    user_requirement: "",
    data_list: [""],
    output_dir: "",
    blacklist: "",
    whitelist: ""
}
// 用于 props 传递
// export type AgentState = {
//   language: string;
//   user_requirement: string;
//   data_list: string[];
//   output_dir: string;
//   blacklist: string;
//   whitelist: string;
//   status: string;
// };



export default function UserInput() {

  const [replayMsg, setReplayMsg] = useState<string | null>(null);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      const replay = params.get("replay");
      if (replay === "state_rnaseq.json") {
        // setReplayMsg("已检测到跳转参数：replay=state_rnaseq.json，正在恢复会话状态...");
        DEFAULT_VALUES={ ...RNA_VALUES }
      } else if (replay === "state_wga.json") {
        // setReplayMsg("已检测到跳转参数：replay=state_whg.json，正在恢复会话状态...");
        DEFAULT_VALUES={ ...WGA_VALUES }
      } else if (replay === "state_chipseq.json") {
        // setReplayMsg("已检测到跳转参数：replay=state_cipseq.json，正在恢复会话状态...");
        DEFAULT_VALUES={ ...CIPSEQ_VALUES }
      }
    }
  }, []);

  const { state, 
          setState ,  
          run: runBioAgent,
  } = useCoAgent<AgentState & { isDataListModified: boolean }>({
    name: "sample_agent",
    initialState: { 
        language: "spanish",
        isDataListModified: false
    }  // optionally provide an initial state
  });


  // const toggleLanguage = async (e: React.FormEvent) => {
  //   const params = new URLSearchParams(window.location.search);
  //   const replay = params.get("replay");
  //   e.preventDefault();
  //   await runBioAgent(() => new TextMessage({
  //           role: MessageRole.User,  
  //           content: `${replay}`,
  //   }));
  //   setState({
  //      ...state, 
  //      language: state.language === "中文" ? "english" : "english" ,
  //      user_requirement: state.user_requirement || DEFAULT_VALUES.user_requirement,
  //      data_list: !state.isDataListModified && (state.data_list === null || state.data_list === undefined || state.data_list.length === 0) 
  //        ? DEFAULT_VALUES.data_list 
  //        : state.data_list,
  //      isDataListModified: true,
  //      output_dir: state.output_dir || DEFAULT_VALUES.output_dir,
  //      blacklist: state.blacklist || DEFAULT_VALUES.blacklist,
  //      whitelist: state.whitelist || DEFAULT_VALUES.whitelist
  //     });
  // };

  const { isLoading } = useCopilotChat();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams(window.location.search);
    const replay = params.get("replay");
    try {
      // const formData = {
      //   user_requirement: bioAgentState.userRequirement,
      //   data_list: state.dataList.filter(Boolean),
      //   output_dir: state.outputDir,
      //   blacklist: state.blacklist,
      //   whitelis:state.whitelist,
      // };
      await runBioAgent(() => new TextMessage({
        role: MessageRole.User,  
        content: `${replay}`,
      }));
    } catch (err) {
      console.error('Error running bio agent:', err);
      setState({
        ...state,
        // error: err instanceof Error ? err.message : '执行过程中发生错误',
      });
    }
  };



  return (

    <div className="space-y-6 bg-neutral-900/80 border border-white/10 p-6 rounded-xl shadow-lg w-3/3 mx-0 ml-0">

        <form onSubmit={handleSubmit} className="space-y-4 bg-neutral-900/60 border border-white/10 p-4 rounded-lg">
          <div>
            <label className="block font-semibold mb-1 text-white">User Requirement</label>
            <textarea
              // type="text"
              rows={2}
              className="w-full p-2 rounded border bg-white/5 border-white/10 text-white placeholder-neutral-500 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-emerald-500/60"
              placeholder={DEFAULT_VALUES.user_requirement}
              value={state.user_requirement ?? ""}
              onChange={e => setState({ ...state, user_requirement: e.target.value })}
            />
          </div>
          <div>
            <label className="block font-semibold mb-1 text-white">Data List (one per line)</label>
            <textarea
              className="w-full p-2 rounded border bg-white/5 border-white/10 text-white placeholder-neutral-500 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-emerald-500/60"
              rows={8}
              placeholder={DEFAULT_VALUES.data_list.join("\n")}
              value={Array.isArray(state.data_list) ? state.data_list.join("\n") : (state.data_list ?? "")}
              onChange={e => {
                const lines = e.target.value.split("\n");
                setState({
                  ...state,
                  data_list: lines.filter(line => line.trim() !== ""),
                  isDataListModified: true
                });
              }}
            />
          </div>
          <div>
            <label className="block font-semibold mb-1 text-white">Output Directory</label>
            <input
              type="text"
              className="w-full p-2 rounded border bg-white/5 border-white/10 text-white placeholder-neutral-500 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-emerald-500/60"
              placeholder={DEFAULT_VALUES.output_dir}
              value={state.output_dir ?? ""}
              onChange={e => setState({ ...state, output_dir: e.target.value })}
            />
          </div>
          <div className="flex gap-4">
            <div className="flex-1">
              <label className="block font-semibold mb-1 text-white">Blacklist</label>
              <input
                type="text"
                className="w-full p-2 rounded border bg-white/5 border-white/10 text-white placeholder-neutral-500 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-emerald-500/60"
                placeholder={DEFAULT_VALUES.blacklist}
                value={state.blacklist ?? ""}
                onChange={e => setState({ ...state, blacklist: e.target.value })}
              />
            </div>
            <div className="flex-1">
              <label className="block font-semibold mb-1 text-white">Whitelist</label>
              <input
                type="text"
                className="w-full p-2 rounded border bg-white/5 border-white/10 text-white placeholder-neutral-500 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-emerald-500/60"
                placeholder={DEFAULT_VALUES.whitelist}
                value={state.whitelist ?? ""}
                onChange={e => setState({ ...state, whitelist: e.target.value })}
              />
            </div>
          </div>
          <button
            disabled={isLoading}
            type="submit"
            className="w-full bg-emerald-500 text-white px-4 py-2 rounded hover:bg-emerald-400 transition disabled:bg-neutral-700 disabled:text-neutral-400 disabled:cursor-not-allowed border border-emerald-400/40 mt-8 font-medium"
          >
            {isLoading ? "处理中..." : "提交"}
          </button>
        </form>

      {/* <div>
        <h1>Your main content</h1>
        <p>Language: {state.language}</p>
        <button onClick={toggleLanguage}>Toggle Language</button> 
      </div> */}
    </div>
  );
}
